import { post } from '../../helpers/axios'

export default async function unApproveCandidate(id) {
  const res = await post(`/starts/${id}/command/unapprove`)
  return res
}
